<template>
  <div class="c-availability">
    <div
      class="o-heading o-heading--border o-grid o-grid--gutter-tiny o-grid--align-items-center"
    >
      <div class="o-grid__group">
        <div class="o-grid__item">
          <h3 class="o-heading o-heading--bold o-heading--size-3">
            {{ translationsAvailability.sectionName || name }}
          </h3>
        </div>
        <div class="o-grid__item o-grid__item--grow-0">
          <CallCenterAEDeditControll
            @save="saveSection()"
            @edit="isEditing = true"
            @cancel="cancelSection()"
          ></CallCenterAEDeditControll>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--gutter-large o-grid--padding-none o-grid--align-items-center o-field o-field--spacing-40 o-field--border o-field--border-none"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--grow-0">
          <div
            class="o-label"
            :title="translationsAvailability.availability || ''"
          >
            {{ translationsAvailability.availability || "" }}
          </div>
        </div>
        <div class="o-grid__item o-grid__item--grow-0">
          <v-select
            :key="resetKey"
            label="name"
            v-model="availabilityAll.availability"
            :options="availabilityOptions"
            :class="{ active: isEditing }"
            :reduce="option => option.value"
            :searchable="true"
            :clearable="false"
            :filterBy="filterDropdownFistLetter"
            :selectOnTab="true"
            :disabled="!isEditing"
            @input="manageState($event)"
          ></v-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "c-availability",
  data() {
    return {
      section: "availability",
      name: "Tilgængelighed",
      isEditing: false,
      resetKey: 0
    };
  },
  computed: {
    ...mapGetters("aed", ["parameters"]),
    ...mapState("availability", {
      availabilityAll: "all",
      defaultAvailability: "defaultAvailability"
    }),
    ...mapState("translations", {
      translationsAvailabilityFull: "availability",
      translationsCustom: "custom"
    }),
    translationsAvailability() {
      return this.translationsAvailabilityFull.availability;
    },

    availabilityOptions() {
      const availabilityOptions = [
        {
          name: this.translationsAvailability.availabilityTypes[0] || "",
          value: "Always"
        },
        {
          name: this.translationsAvailability.availabilityTypes[1] || "",
          value: "OpeningHours"
        },
        {
          name: this.translationsAvailability.availabilityTypes[2] || "",
          value: "BehindLock"
        }
      ];
      return availabilityOptions;
    }
  },
  methods: {
    saveSection() {
      this.isEditing = false;
      const data = JSON.parse(JSON.stringify(this.availabilityAll));
      if (this.availabilityAll.availability !== "OpeningHours") {
        delete data.weekdays;
        delete data.holidays;
        delete data.special;
        delete data.closed;
      }

      const payload = {
        method: "PUT",
        api: this.$api,
        id: this.$store.state.aed.all.id,
        section: this.section,
        data: data
      };
      const { dispatch } = this.$store;
      dispatch("aed/setSection", payload);
    },
    cancelSection() {
      this.resetKey += 1;
      this.isEditing = false;
      this.$store.dispatch("availability/setAvailabilityStateToInitial");
    },

    manageState(availabilityType) {
      this.availabilityAll.availability = availabilityType;
      if (availabilityType === "OpeningHours") {
        this.$store.dispatch("availability/setAvailabilityStateToDefault");
      }
    }
  },
  watch: {
    isEditing: function() {
      this.$emit("stateChange", this.isEditing);
    }
  }
};
</script>

<style lang="scss">
.c-availability {
}
</style>
